import defaultClient from '@src/api/clients/default';

export function fetchClientTerritories(clientId) {
  return defaultClient.request({
    url: 'dashboard/client-territories/',
    options: { params: { client_id: clientId } },
  });
}
